import React from "react";
import "@/app/pages/companyProfile/financial/CompanyNewFinancialsStyles.scss";
import { formatData } from "@/shared/FunctionCore";

const Liabilities = ({ props }) => {
  return (
    <>
      <table>
        <thead>
          <th className="statement_name th" scope="col">
            Liabilities (MIL)
          </th>
          {props.liabilities.liabilitiesYear.map((liabilityYear) => (
            <>
              <th className="statement_year th" scope="col">
                {liabilityYear}
              </th>
            </>
          ))}
        </thead>
        <tbody>
          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Current Liabilities
            </th>
            {props.liabilities?.totalLibalities.map((netOperatingCash) => (
              <>
                <td className="statement_year th" scope="col"></td>
              </>
            ))}
          </tr>

          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Accounts Payable
            </th>
            {props.liabilities.accountPayable.map((accountPayable) => (
              <>
                <td className="statement_year th" scope="col">
                  {formatData(accountPayable)}
                </td>
              </>
            ))}
          </tr>

          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Short-Term Debt
            </th>
            {props.liabilities.shortTermDebt.map((shortTermDebt) => (
              <>
                <td className="statement_year th" scope="col">
                  {formatData(shortTermDebt)}
                </td>
              </>
            ))}
          </tr>

          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Other Current Liabilities
            </th>
            {props.liabilities.otherCurrentLiablities.map(
              (otherCurrentLiablities) => (
                <>
                  <td className="statement_year th" scope="col">
                    {formatData(otherCurrentLiablities)}
                  </td>
                </>
              )
            )}
          </tr>

          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Liability Summary
            </th>
            {props.liabilities?.totalLibalities.map((cashAtBeginning) => (
              <>
                <td className="statement_year th" scope="col"></td>
              </>
            ))}
          </tr>

          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Total Current Liabilities
            </th>
            {props.liabilities.totalCurrentLiablities.map(
              (totalCurrentLiablities) => (
                <>
                  <td className="statement_year th" scope="col">
                    {formatData(totalCurrentLiablities)}
                  </td>
                </>
              )
            )}
          </tr>

          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Long-Term Debt
            </th>
            {props.liabilities.longTermDebt.map((longTermDebt) => (
              <>
                <td className="statement_year th" scope="col">
                  {formatData(longTermDebt)}
                </td>
              </>
            ))}
          </tr>

          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Other Long-Term Liabilities
            </th>
            {props.liabilities?.nonCurrentLiablities.map(
              (nonCurrentLiablities) => (
                <>
                  <td className="statement_year th" scope="col">
                    {formatData(nonCurrentLiablities)}
                  </td>
                </>
              )
            )}
          </tr>

          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Total Liabilities
            </th>
            {props.liabilities.totalLibalities.map((totalLibalities) => (
              <>
                <td className="statement_year th" scope="col">
                  {formatData(totalLibalities)}
                </td>
              </>
            ))}
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default Liabilities;
